// extracted by mini-css-extract-plugin
export default {"link":"ButtonSidebar_link__fsSAS","active":"ButtonSidebar_active__GKKXl"};